import { IChartState } from './types';

export function addChartsToExport (charts: IChartState) {
  return {
    type: 'ADD_CHART_TO_EXPORT',
    payload: {
      charts,
    },
  };
}
